import { useEffect, useRef } from "react";
import L from "leaflet";

const DARK_TILES = "https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png";

/** Playback map: draws the recorded breadcrumb path and a marker at the current frame. */
export const PlaybackMap = ({ pings, index }) => {
  const holder = useRef(null);
  const mapRef = useRef(null);
  const lineRef = useRef(null);
  const markerRef = useRef(null);

  useEffect(() => {
    if (mapRef.current) return;
    const map = L.map(holder.current, { center: [25.9, 93.7], zoom: 7 });
    L.tileLayer(DARK_TILES, { maxZoom: 19, attribution: "© OpenStreetMap, © CARTO" }).addTo(map);
    mapRef.current = map;
    return () => {
      map.remove();
      mapRef.current = null;
    };
  }, []);

  useEffect(() => {
    const map = mapRef.current;
    if (!map) return;
    if (lineRef.current) {
      map.removeLayer(lineRef.current);
      lineRef.current = null;
    }
    if (pings.length === 0) return;
    const latlngs = pings.map((p) => [p.lat, p.lng]);
    lineRef.current = L.polyline(latlngs, { color: "#00F0FF", weight: 2, opacity: 0.6 }).addTo(map);
    map.fitBounds(lineRef.current.getBounds(), { padding: [60, 60], maxZoom: 13 });
  }, [pings]);

  useEffect(() => {
    const map = mapRef.current;
    const ping = pings[index];
    if (!map || !ping) return;
    const icon = L.divIcon({
      className: "",
      html: `<div class="doot-marker moving"><div class="ring"></div><div class="core" style="background:#00FF66"></div><div class="plate">${Number(
        ping.speed_kmh || 0
      ).toFixed(0)} KM/H</div></div>`,
      iconSize: [34, 34],
      iconAnchor: [17, 17],
    });
    if (markerRef.current) {
      markerRef.current.setLatLng([ping.lat, ping.lng]);
      markerRef.current.setIcon(icon);
    } else {
      markerRef.current = L.marker([ping.lat, ping.lng], { icon }).addTo(map);
    }
    map.panTo([ping.lat, ping.lng], { animate: true, duration: 0.4 });
  }, [pings, index]);

  return <div ref={holder} data-testid="playback-map" className="h-full w-full" />;
};
